import React from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import PersonAdaptToClient from "@parts/person/personAdaptToClient";

import {
  setFancyName,
  setStateRegistry,
} from "@parts/person/personAdaptToCompany/actions";
import {
  setBasePersonName,
  setBasePersonEmail,
  setBasePersonPhoneNumber,
  setPersonType,
  setPersonDoc,
} from "@parts/person/actions";

import {
  setPostalCode,
  setStreetNumber,
  setComplement,
  setStateLocation,
  setCityLocation,
  setStreet,
  setDistrict,
} from "@parts/address-component/actions";

import { get, api, put } from "@config";
import { getStates, getCityById } from "@parts/utils";
import { notification } from "antd";

class EditClient extends React.Component {
  constructor(props) {
    super(props);
    this.state = { clientId: "" };
    this.callback = this.callback.bind(this);
    this.updateBranch = this.updateBranch.bind(this);
  }

  updateBranch(data) {
    const { clientId } = this.state; 
    const url = `${api.branches}${clientId}/`;
    const payload = resp => {
      notification.open({
        message: "Cliente atualizado com sucesso!",
        type: "success",
        duration: 3,
        key: "9432"
      })
      window.location.href = '/accountant/clients/list'
    }
    const errPayload = resp => {
      notification.open({
        message: "Erro ao atualizar cliente!",
        type: "error",
        duration: 3,
        key: "9431"
      })
    }
    put(url, data, payload, errPayload);
  }

  callback(client) {
    window.location.href = "/accountant/clients/list";
  }

  _setPersonData(name, email, phone_number) {
    this.props.setBasePersonName(name);
    this.props.setBasePersonPhoneNumber(phone_number);
    this.props.setBasePersonEmail(email);
  }

  _setIndidualData(individual) {
    this.props.setPersonType(0);
    this.props.setPersonDoc(individual.cpf);
  }

  _setCompanyData(company) {
    this.props.setPersonType(1);
    this.props.setFancyName(company.fancy_name);
    this.props.setStateRegistry(company.state_registry);
    this.props.setPersonDoc(company.cnpj);
  }

  _getStateLocation(ufCode) {
    const payload = (states) => {
      const [state] = states;
      state.label = state.uf;
      state.valud = state.id;
      this.props.setStateLocation(state);
    };
    getStates(payload, ufCode);
  }

  _getCityLocation(cityId) {
    const payload = (city) => {
      this._getStateLocation(city.uf_code);
    };
    getCityById(cityId, payload);
  }
  _setAddressData(address) {
    this.props.setPostalCode(address.postal_code);
    this.props.setDistrict(address.district);
    this.props.setStreet(address.street);
    this.props.setStreetNumber(address.street_number);
    this.props.setComplement(address.complement);

    const city = {
      label: address.city,
      value: address.city_id,
      id: address.city_id,
    };
    this.props.setCityLocation(city);
    this._getCityLocation(address.city_id);
  }

  _getClientData(id) { 
    const url = `${api.branches}${id}/`;
    get(url, (client) => {
      this._setPersonData(client.name, client.email, client.phone_number);
      this._setAddressData(client.address);
      if (client.company) {
        this._setCompanyData(client.company);
      } else {
        this._setIndidualData(client.individual);
      }
    });
  }

  UNSAFE_componentWillMount() {
    const id = window.location.pathname.split("/client/")[1];
    this.setState({ ...this, clientId: id });
    this._getClientData(id);
  }
  render() {
    return (
      <PersonAdaptToClient 
        clientId={this.state.clientId}
        mei crt
        updateBranch={this.updateBranch}
      />
    );
  }

  componentWillUnmount() {
    const blank = { label: "", value: "" };
    this.props.setBasePersonName("");
    this.props.setBasePersonEmail("");
    this.props.setBasePersonPhoneNumber("");
    this.props.setPersonType(0);
    this.props.setPersonDoc("");
    this.props.setFancyName("");
    this.props.setStateRegistry("");

    this.props.setPostalCode("");
    this.props.setStreetNumber("");
    this.props.setComplement("");
    this.props.setStateLocation(blank);
    this.props.setCityLocation(blank);
    this.props.setStreet("");
    this.props.setDistrict("");
  }
}

const mapStateToProps = (state) => ({
  type: state.personType,
});

const mapDispatchToProps = (disptach) =>
  bindActionCreators(
    {
      setBasePersonName,
      setBasePersonEmail,
      setBasePersonPhoneNumber,
      setPersonType,
      setPersonDoc,
      setFancyName,
      setStateRegistry,

      setPostalCode,
      setStreetNumber,
      setComplement,
      setStateLocation,
      setCityLocation,
      setStreet,
      setDistrict,
    },
    disptach
  );
export default connect(mapStateToProps, mapDispatchToProps)(EditClient);



// WEBPACK FOOTER //
// ./src/components/pages/accountant/edit/index.jsx